module.exports = __webpack_public_path__ + "assets/img/19_858_big.91d4e248.jpg";